export default __webpack_public_path__ + "static/media/ic_file_download.9f0a5b05.svg";